import { Alert } from '@heroui/react';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

interface PreopVisitCardProps {
  preOpDate: Dayjs | null | undefined;
  startOfDayInHospitalTz: Dayjs | null | undefined;
}

export function PreopVisitCard({
  preOpDate,
  startOfDayInHospitalTz,
}: PreopVisitCardProps) {
  const { t } = useTranslation('home');

  const daysToPreop = dayjs(preOpDate)
    .startOf('day')
    .diff(startOfDayInHospitalTz, 'days');

  const date = dayjs(preOpDate).format('LL');
  const time =
    dayjs(preOpDate).hour() === 0 ? null : dayjs(preOpDate).format('h:mm a');

  let text = t('preopvisitcard.countdown', { date });

  if (daysToPreop === 0) {
    text = t('preopvisitcard.countdown_0');
  }

  if (time) {
    text += ` ${t('preopvisitcard.time', { time })}`;
  }

  if (daysToPreop >= 0) {
    return (
      <Alert color="primary" hideIconWrapper title={text} variant="faded" />
    );
  }

  return null;
}
